import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div class={{this.classNames}} {{did-insert this.setupEventListeners}}>
  <div class="search-input">
    {{#if this.search.inTopicContext}}
      <DButton
        @icon="times"
        @label="search.in_this_topic"
        @title="search.in_this_topic_tooltip"
        @action={{this.clearTopicContext}}
        class="btn-small search-context"
      />
    {{else if this.inPMInboxContext}}
      <DButton
        @icon="times"
        @label="search.in_messages"
        @title="search.in_messages_tooltip"
        @action={{this.clearPMInboxContext}}
        class="btn-small search-context"
      />
    {{/if}}

    <PluginOutlet
      @name="search-menu-before-term-input"
      @outletArgs={{hash openSearchMenu=this.open}}
    />

    <SearchMenu::SearchTerm
      @searchTermChanged={{this.searchTermChanged}}
      @typeFilter={{this.typeFilter}}
      @updateTypeFilter={{this.updateTypeFilter}}
      @triggerSearch={{this.triggerSearch}}
      @fullSearch={{this.fullSearch}}
      @clearPMInboxContext={{this.clearPMInboxContext}}
      @clearTopicContext={{this.clearTopicContext}}
      @closeSearchMenu={{this.close}}
      @openSearchMenu={{this.open}}
      @autofocus={{@autofocusInput}}
    />

    {{#if this.loading}}
      <div class="searching">
        {{loading-spinner}}
      </div>
    {{else}}
      <div class="searching">
        <PluginOutlet @name="search-menu-before-advanced-search" />
        {{#if this.search.activeGlobalSearchTerm}}
          <SearchMenu::ClearButton @clearSearch={{this.clearSearch}} />
        {{/if}}
        <SearchMenu::AdvancedButton
          @openAdvancedSearch={{this.openAdvancedSearch}}
        />
      </div>
    {{/if}}
  </div>

  {{#if @inlineResults}}
    <SearchMenu::Results
      @loading={{this.loading}}
      @invalidTerm={{this.invalidTerm}}
      @suggestionKeyword={{this.suggestionKeyword}}
      @suggestionResults={{this.suggestionResults}}
      @searchTopics={{this.includesTopics}}
      @inPMInboxContext={{this.inPMInboxContext}}
      @triggerSearch={{this.triggerSearch}}
      @updateTypeFilter={{this.updateTypeFilter}}
      @closeSearchMenu={{this.close}}
      @searchTermChanged={{this.searchTermChanged}}
      @clearSearch={{this.clearSearch}}
    />
  {{else if this.displayMenuPanelResults}}
    <MenuPanel @panelClass="search-menu-panel">
      <SearchMenu::Results
        @loading={{this.loading}}
        @invalidTerm={{this.invalidTerm}}
        @suggestionKeyword={{this.suggestionKeyword}}
        @suggestionResults={{this.suggestionResults}}
        @searchTopics={{this.includesTopics}}
        @inPMInboxContext={{this.inPMInboxContext}}
        @triggerSearch={{this.triggerSearch}}
        @updateTypeFilter={{this.updateTypeFilter}}
        @closeSearchMenu={{this.close}}
        @searchTermChanged={{this.searchTermChanged}}
        @clearSearch={{this.clearSearch}}
      />
    </MenuPanel>
  {{/if}}
</div>
*/
{
  "id": "5NbPd6RR",
  "block": "[[[11,0],[16,0,[30,0,[\"classNames\"]]],[4,[38,0],[[30,0,[\"setupEventListeners\"]]],null],[12],[1,\"\\n  \"],[10,0],[14,0,\"search-input\"],[12],[1,\"\\n\"],[41,[30,0,[\"search\",\"inTopicContext\"]],[[[1,\"      \"],[8,[39,2],[[24,0,\"btn-small search-context\"]],[[\"@icon\",\"@label\",\"@title\",\"@action\"],[\"times\",\"search.in_this_topic\",\"search.in_this_topic_tooltip\",[30,0,[\"clearTopicContext\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"inPMInboxContext\"]],[[[1,\"      \"],[8,[39,2],[[24,0,\"btn-small search-context\"]],[[\"@icon\",\"@label\",\"@title\",\"@action\"],[\"times\",\"search.in_messages\",\"search.in_messages_tooltip\",[30,0,[\"clearPMInboxContext\"]]]],null],[1,\"\\n    \"]],[]],null]],[]]],[1,\"\\n    \"],[8,[39,3],null,[[\"@name\",\"@outletArgs\"],[\"search-menu-before-term-input\",[28,[37,4],null,[[\"openSearchMenu\"],[[30,0,[\"open\"]]]]]]],null],[1,\"\\n\\n    \"],[8,[39,5],null,[[\"@searchTermChanged\",\"@typeFilter\",\"@updateTypeFilter\",\"@triggerSearch\",\"@fullSearch\",\"@clearPMInboxContext\",\"@clearTopicContext\",\"@closeSearchMenu\",\"@openSearchMenu\",\"@autofocus\"],[[30,0,[\"searchTermChanged\"]],[30,0,[\"typeFilter\"]],[30,0,[\"updateTypeFilter\"]],[30,0,[\"triggerSearch\"]],[30,0,[\"fullSearch\"]],[30,0,[\"clearPMInboxContext\"]],[30,0,[\"clearTopicContext\"]],[30,0,[\"close\"]],[30,0,[\"open\"]],[30,1]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"loading\"]],[[[1,\"      \"],[10,0],[14,0,\"searching\"],[12],[1,\"\\n        \"],[1,[34,6]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[14,0,\"searching\"],[12],[1,\"\\n        \"],[8,[39,3],null,[[\"@name\"],[\"search-menu-before-advanced-search\"]],null],[1,\"\\n\"],[41,[30,0,[\"search\",\"activeGlobalSearchTerm\"]],[[[1,\"          \"],[8,[39,7],null,[[\"@clearSearch\"],[[30,0,[\"clearSearch\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"        \"],[8,[39,8],null,[[\"@openAdvancedSearch\"],[[30,0,[\"openAdvancedSearch\"]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\\n\"],[41,[30,2],[[[1,\"    \"],[8,[39,9],null,[[\"@loading\",\"@invalidTerm\",\"@suggestionKeyword\",\"@suggestionResults\",\"@searchTopics\",\"@inPMInboxContext\",\"@triggerSearch\",\"@updateTypeFilter\",\"@closeSearchMenu\",\"@searchTermChanged\",\"@clearSearch\"],[[30,0,[\"loading\"]],[30,0,[\"invalidTerm\"]],[30,0,[\"suggestionKeyword\"]],[30,0,[\"suggestionResults\"]],[30,0,[\"includesTopics\"]],[30,0,[\"inPMInboxContext\"]],[30,0,[\"triggerSearch\"]],[30,0,[\"updateTypeFilter\"]],[30,0,[\"close\"]],[30,0,[\"searchTermChanged\"]],[30,0,[\"clearSearch\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"displayMenuPanelResults\"]],[[[1,\"    \"],[8,[39,10],null,[[\"@panelClass\"],[\"search-menu-panel\"]],[[\"default\"],[[[[1,\"\\n      \"],[8,[39,9],null,[[\"@loading\",\"@invalidTerm\",\"@suggestionKeyword\",\"@suggestionResults\",\"@searchTopics\",\"@inPMInboxContext\",\"@triggerSearch\",\"@updateTypeFilter\",\"@closeSearchMenu\",\"@searchTermChanged\",\"@clearSearch\"],[[30,0,[\"loading\"]],[30,0,[\"invalidTerm\"]],[30,0,[\"suggestionKeyword\"]],[30,0,[\"suggestionResults\"]],[30,0,[\"includesTopics\"]],[30,0,[\"inPMInboxContext\"]],[30,0,[\"triggerSearch\"]],[30,0,[\"updateTypeFilter\"]],[30,0,[\"close\"]],[30,0,[\"searchTermChanged\"]],[30,0,[\"clearSearch\"]]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]],null]],[]]],[13]],[\"@autofocusInput\",\"@inlineResults\"],false,[\"did-insert\",\"if\",\"d-button\",\"plugin-outlet\",\"hash\",\"search-menu/search-term\",\"loading-spinner\",\"search-menu/clear-button\",\"search-menu/advanced-button\",\"search-menu/results\",\"menu-panel\"]]",
  "moduleName": "discourse/components/search-menu.hbs",
  "isStrictMode": false
});